// extracted by mini-css-extract-plugin
module.exports = {"MinTitle":"MinTitle_MinTitle__Fu0ry"};